import Zoom from "@arcgis/core/widgets/Zoom";
export function zoom(zoomSettings) {
    let zoom = new Zoom({
        view: zoomSettings.view
    });
    zoomSettings.view.ui.add(zoom, zoomSettings.controlPosition);
}
